import axios from "axios";

/**
 * Which API this page talks to, decided by where it is served.
 *
 * This app has no build-time environment of its own: the same image runs at
 * staging.kyou.id/help and kyou.id/help. It used to call production from both,
 * which on staging meant sending a staging login token to the production API
 * and getting 401s back -- everyone looked logged out. hanamaru's task
 * definitions (deployment/*-task-fargate.yaml) are the source for these hosts.
 */
const API_HOST =
  typeof window !== "undefined" && /(^|\.)staging\.kyou\.id$/.test(window.location.hostname)
    ? "https://api.staging.kyou.id"
    : "https://api.kyou.id";

export const API_V1 = `${API_HOST}/api`;
export const API_V2 = `${API_HOST}/v2`;

const STAGING =
  typeof window !== "undefined" && /(^|\.)staging\.kyou\.id$/.test(window.location.hostname);

/**
 * Whether the visitor is logged in on kyou.id.
 *
 * The session is the HttpOnly `kyou_at` cookie (KYOU-32): JS cannot read it,
 * and the browser sends it to api.kyou.id only with `withCredentials`. Beside
 * it the server sets a readable `kyou_session=1` marker, which is all this page
 * needs to know. The old readable `access_token` cookie -- what the 13 Oct 2026
 * injected script read -- is no longer written on production.
 */
export function isLoggedIn() {
  if (typeof document === "undefined") return false;
  if (/(?:^|;\s*)kyou_session=1(?:;|$)/.test(document.cookie)) return true;
  return STAGING && legacyToken() !== null;
}

// Staging still runs on the readable cookie; production never reads it.
function legacyToken() {
  if (!STAGING || typeof document === "undefined") return null;
  const match = document.cookie.match(/(?:^|;\s*)access_token=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

const request = axios.create({ baseURL: API_V1 });

export default request;

export const authRequest = (baseURL = API_V1) => {
  const token = legacyToken();
  return axios.create({
    baseURL,
    withCredentials: !STAGING,
    headers: token ? { authorization: `Bearer ${token}` } : {}
  });
};
